import React from "react";
import tw from "twin.macro";
import Marquee from "react-fast-marquee";
import Card from "./ProjectCard";
import { useTranslation } from "react-i18next";
import KashimaDogClubImg from "../../images/project-showcase/kashima.png";
import chatbotImg from "../../images/project-showcase/chatbot.png";
import nextcloudImg from "../../images/project-showcase/next-cloud.png";
import marketImg from "../../images/project-showcase/market-bridge-japan.png";
import talkImg from "../../images/project-showcase/talk.png";
import taskImg from "../../images/project-showcase/Task.png";
import BgTitle from "components/title/BgTitle";

const Container = tw.div`relative mx-auto px-6 max-w-screen-xl`;

const images = [
  chatbotImg,
  nextcloudImg,
  marketImg,
  KashimaDogClubImg,
  taskImg,
  talkImg
];

export default ({ isXs = false }) => {
  const { t } = useTranslation();

  // Board members' data from translation
  const cardsData = t("project_showcase_items", { returnObjects: true });

  return (
    <div style={{ margin: "20px 0px" }}>
      <Container>
        <BgTitle text={t("project_showcase_headline")} />
      </Container>
      <Marquee
        gradientColor="#fafafa"
        direction={isXs ? "left" : "right"}
        gradient={!isXs}
      >
        {[...cardsData, ...cardsData].map((card, index) => (
          <Card
            key={index}
            imageSrc={images[index % images.length]} // Modulo ensures no undefined index
            title={card.title}
          />
        ))}
      </Marquee>
      {!isXs && (
        <Marquee gradientColor="#fafafa" direction={"left"} gradient={!isXs}>
          {[...cardsData, ...cardsData].map((card, index) => (
            <Card
              key={index}
              imageSrc={images[index % images.length]} // Modulo ensures no undefined index
              title={card.title}
            />
          ))}
        </Marquee>
      )}
    </div>
  );
};
